export default __webpack_public_path__ + "media/images/furnished_apartments/section_right_img2-9193e9370be52c11757e84a5666e7add.png";